import { Point, PointResponse } from "../point/point.model";

export type ConversionTableResponse = PointResponse &
  Pick<ConversionTable, "values" | "offset" | "maxItems" | "xAxis" | "yAxis">;
export class ConversionTable extends Point {
  values?: number[][];
  offset?: number;
  maxItems?: number;
  xAxis?: string;
  yAxis?: string;

  constructor(data: ConversionTableResponse) {
    super(data);
    this.values = data.values;
    this.offset = data.offset;
    this.maxItems = data.maxItems;
    this.xAxis = data.xAxis;
    this.yAxis = data.yAxis;
  }
}
